var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevron-left"),React.createElement("path",{"d":"M22.13,36.83L7.34,22a1.36,1.36,0,0,1,0-1.92l14.6-14.6","transform":"translate(-4.19 -2.77)","style":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"5.49805142246211px"},"key":1})]);
}

ChevronLeft.defaultProps = {"viewBox":"0 0 20.68 36.81"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;



//////////////////
// WEBPACK FOOTER
// ./app/components/setup/chevron-left.svg
// module id = ./app/components/setup/chevron-left.svg
// module chunks = 1